module.exports = __webpack_public_path__ + "img/header_logo.8f95e5da.png";